export default {
  common: {
    backLink: '← 全文検索くん (Search++) へ戻る',
    purchaseLabel: 'ライセンスを購入（Stripe）',
    trialDownload: '体験版をダウンロード',
    contact: 'お問い合わせ: <a href="mailto:searchkun@gmail.com">searchkun@gmail.com</a>',
    copyright: 'Copyright(c) All rights reserved.'
  },
  nav: {
    items: ['製品情報', '特徴', '更新履歴', 'お客様の声', 'ご購入', 'リンク', 'FAQ', 'ユーザ登録']
  },
  home: {
    title1: 'インデックス型全文検索ツール',
    title2: '全文検索くん (Search++)',
    updateDate: '最新更新日：2026年9月28日',
    evalLabel: 'ベクター社の評価：”安心感”の高い検索結果',
    specTitle: '製品仕様・価格',
    detailLink: '製品詳細・ダウンロード →',
    shareware: 'シェアウェアです。30日間、全機能の試用が可能です。',
    memoTitle: '重要な注意事項',
    memo1: 'Windows XPの場合、<a href="https://www.microsoft.com/en-us/download/details.aspx?id=26368" target="_blank">Microsoft VC++ 2008 SP1 再頒布可能パッケージ</a>をインストールする必要があります。',
    spec: [
      {
        id: '1',
        name: 'Search++ Std版',
        icon: 'el-icon-monitor',
        color: 'color:#409EFF',
        version: '6.2.1.3',
        OS: 'Windows XP, 7, Vista, Server 2003/2008, 8, 10',
        Bit: '32Bit / 64Bit',
        price: '3,410円（税込）',
        priceType: '',
        feature: '32Bit・64Bit対応。1GB以下のメモリ利用制限があります。'
      },
      {
        id: '2',
        name: 'Search++ Pro版',
        icon: 'el-icon-monitor',
        color: 'color:#67C23A',
        version: '6.2.1.3',
        OS: 'Windows 10, 11',
        Bit: '64Bit',
        price: '5,602円（税込）',
        priceType: '',
        feature: '64Bit特化。メモリ制限なし'
      },
      {
        id: '3',
        name: 'Search++ Mac OS版',
        icon: 'el-icon-monitor',
        color: 'color:#E6A23C',
        OS: 'macOS',
        Bit: '64Bit',
        price: '5,602円（税込）',
        priceType: '',
        feature: 'Pro版と同機能。実行前にセキュリティ設定での許可が必要です。'
      },
      {
        id: '4',
        name: 'MojiScan',
        icon: 'el-icon-document',
        color: 'color:#0c86e8',
        OS: 'Windows 10, 11',
        Bit: '64Bit',
        price: '3,410円（税込）',
        priceType: 'primary',
        priceStyle: 'background-color:#0c86e8;border-color:#0c86e8;',
        feature: '日本語OCR、PDF編集、合併、分割など操作をサポート、Search++と連携可能',
        linkTo: '/mojiscan'
      },
      {
        id: '5',
        name: 'BookMarkSearch',
        icon: 'el-icon-link',
        color: 'color:#7958DB',
        OS: 'Windows 10, 11',
        Bit: '64Bit',
        price: '3,410円（税込）',
        priceType: 'warning',
        feature: 'ブラウザのブックマークと閲覧履歴をタイトル、URL、フォルダ、ページ本文から全文検索。Search++シリーズ。',
        linkTo: '/bookmarksearch'
      },
      {
        id: '6',
        name: 'SlackInvoice',
        icon: 'el-icon-chat-dot-round',
        color: 'color:#4A154B',
        OS: 'Slack',
        Bit: 'Web',
        price: '早期アクセス中は無料',
        priceType: 'success',
        feature: 'Slack上でStripeの請求書を作成・送信、顧客管理、入金通知ができます。無料でお試しいただけます。',
        linkTo: 'https://www.searchplusplus.jp/slackinvoice',
        external: true
      }
    ]
  },
  feature: {
    featuresTitle: '主要機能',
    demoTitle: 'デモンストレーション',
    manualTitle: 'マニュアル',
    manualStd: '標準版',
    manualPro: 'Pro版',
    previewStd: 'manual.pdf (プレビュー)',
    previewPro: 'manual_pro.pdf (プレビュー)',
    popoverStd: '標準版マニュアル',
    popoverPro: 'Pro版マニュアル',
    openInNewWindow: '別ウィンドウで開く',
    items: [
      {
        id: '1',
        icon: 'el-icon-files',
        feature: '多種多様なファイル形式をサポート',
        childrenFeatures: [
          'MS PowerPoint (PPT, PPTX)',
          'MS Word (RTF, DOC, DOCX)',
          'MS Excel (XLS, XLSX)',
          'MS Outlook (MSG, EML)',
          'MS Visio (VSD)',
          'HTML, HTM',
          'Open Office Format (ODT etc.)',
          '一太郎',
          'Fuji Xerox Docuworks (IFILTERが必要)',
          '各種テキスト (*.txt, *.log, *.java, *.cpp, *.c, *.bat, *.config)',
          'PDF (OCR済み推奨)'
        ]
      },
      {
        id: '2',
        icon: 'el-icon-setting',
        feature: 'シンプルな導入プロセス',
        childrenFeatures: [
          '標準版: 解凍するだけで実行可能',
          'Pro版: 同梱のStartup.exeで初期設定を行うだけの簡単ステップ'
        ]
      },
      {
        id: '3',
        icon: 'el-icon-search',
        feature: '高速なインデックス型検索',
        childrenFeatures: [
          '指定フォルダ以下の全ファイルを高速スキャン',
          '常駐モードによる自動インデックス更新',
          '非常駐モードでの差分更新（即時更新ボタン）'
        ]
      },
      {
        id: '4',
        icon: 'el-icon-view',
        feature: '充実したプレビュー機能',
        childrenFeatures: [
          '検索結果から該当箇所の抜粋を表示',
          'ファイル内容を直接閲覧・確認可能'
        ]
      }
    ]
  },
  download: {
    titleDownload: 'ダウンロード',
    titlePurchase: 'ご購入方法',
    day30trial: '30日間全機能の試用が可能です、どうぞご購入前にご試用いただければありがたいです',
    products: [
      {
        name: '全文検索くん標準版',
        desc: [
          '標準版は32ビットOSも64ビットOSもサポートしています、インストール必要ないが、最大処理ファイルは３０MB以下になります。',
          '（32ビットをサポートするため、利用可能メモリの制限があります）'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6213/SearchStd6213_J.zip">標準版(Version6.2.1.3)のダウンロード(zip)　<=ダウンロードしたら展開を忘れないで下さい</a>'
        ],
        guide: '標準版簡単導入の手引き'
      },
      {
        name: '全文検索くんPro版',
        desc: [
          'Pro版は64ビットOSだけサポートしています、インストール必要ですが、64ビットOSの能力を発揮できて、大きいサイズのファイルも処理できます。',
          '（例: デフォルト設定で、５００MB自炊PDF処理できます）'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6213/SearchPro6213_J.zip">Pro版(Version6.2.1.3)のダウンロード(zip)　<=ダウンロードしたら展開を忘れないで下さい</a>'
        ],
        guide: 'Pro版簡単導入の手引き'
      },
      {
        name: '全文検索くんMac版',
        desc: [
          'Mac OS用のバージョンです。dmgファイルをクリックしてApplicationsフォルダへコピーしてください。完了したら、Applicationsフォルダ下のSearchpluplus.appを起動すれば結構です。'
        ],
        links: [
          '<a href="https://www.searchplusplus.jp/download/6101/SearchMac6101.dmg">Mac版(Version6.1.0.1)のダウンロード(dmg)</a>'
        ],
        guide: ''
      }
    ],
    purchase: [
      {
        id: '0',
        name: '購入方法一',
        subtitle: '作者へ直接連絡してからのご購入',
        steps: [
          '購入したい旨を問い合わせ先(searchkun@gmail.com)にメールをください',
          '当方より代金(標準版税込み:3410円、Pro版税込み:5602円、Mac版税込み:5602円)の振込先の銀行口座を連絡します',
          '指定口座へ代金の振込みをお願いします',
          '振込みが完了しましたら、その旨、メールにて連絡くださった当方が振込みを確認いたしましたら、ライセンス情報およびダウンロード先をメールにて送付いたします'
        ]
      },
      {
        id: '1',
        name: '購入方法二',
        subtitle: 'Paypal経由でクレジットカードで払う',
        steps: [
          ['下記アイコンをクリックして、Paypal社の購入画面に行きます（標準版税込み:3410円、Pro版税込み:5602円、Mac版税込み:5602円）',
            '<div style="display:flex;">',
            '<h4 style="color:DarkBlue;font-weight:bold">標準版</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="KECBBA27LQ6GJ">',
            '<input type="image" src="https://www.searchplusplus.jp/stdbuy.png" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">',
            '<img alt="" border="0" title="標準版" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '<h4 style="color:ForestGreen;font-weight:bold;padding-left: 10px">Pro版</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="ETWN4J2CB5E9A">',
            '<input type="image" src="https://www.searchplusplus.jp/probuy.png" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">',
            '<img alt="" border="0" title="Pro版" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '<h4 style="color:Indigo;font-weight:bold;padding-left: 10px">Mac版</h4>',
            '<form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post">',
            '<input type="hidden" name="cmd" value="_s-xclick">',
            '<input type="hidden" name="hosted_button_id" value="723FVNH3H89PN">',
            '<input type="image" src="https://www.searchplusplus.jp/macbuy.png" border="0" name="submit" alt="PayPal - オンラインでより安全・簡単にお支払い">',
            '<img alt="" border="0" title="Mac版" src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif" width="1" height="1">',
            '</form>',
            '</div>'
          ].join('\n'),
          '数量を設定して、「更新」ボタンをおして、金額を更新します',
          '「Paypalでチェックアウト」ボタンを押して、次の画面に行きます',
          '「クレジットカードで支払う」リンクをクリックして、カード情報、Eメールアドレスを入れて、「支払う」ボタンを押しますと、Paypal社から連絡メールが当方に来ます',
          '当方はPaypalからの連絡が着たら、ライセンスキーをステップ３で登録した Eメールアドレス当てに送付いたします'
        ]
      },
      {
        id: '2',
        name: '購入方法三',
        subtitle: 'Vector社経由でのご購入（標準版税込み＋レジ手数料:3410円、Pro版税込み＋レジ手数料:5602円、Mac版税込み＋レジ手数料:5602円）',
        steps: [
          '<a href="https://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR296240">標準版の購入</a>',
          '<a href="https://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR378160">Pro版の購入</a>',
          '<a href="https://s.shop.vector.co.jp/service/servlet/NCart.Add?ITEM_NO=SR442842">Mac版の購入</a>'
        ]
      }
    ]
  },
  link: {
    title: 'リンク集',
    ifilter: [
      'V2.8.2から全文検索くん（Search++）はマイクロソフト社IFILTERのインタフェースをサポートしました。',
      'Windows XP, Windows Vista, Windows7 32Bit,　Windows7　64Bit, Windows 8, Windows 10環境で下記各社の製品へのインタフェースが実装して、正しく動作することを確認できました。',
      'IFILTER製品自体は各社の使用条件を確認したうえで、ダウンロードしてのご利用をお願いします、IFILTER製品自体に対してこちらのサポート対象外です。よろしくお願いします。'
    ],
    filterCards: [
      {
        name: '<a href="http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611" target="blank">【縦書きPDF】</a>',
        desc: [
          '１）まず、PDFに対してIFILTERを使用するように、設定ファイル（Config.xml）に一行を追加します、',
          '<IFilter.pdf>1</IFilter.pdf>',
          '（全文検索くんは実行中の場合、設定を変更する前に、全文検索くんを停止させる必要です）',
          '２）Windows Vista, Windows 7, Windows 8では上記リンクからソフトウェアをダウンロードして、インストールして、インデックス作成すれば、検索できるようになります。',
          '縦書きPDFをサポートする場合、インデックス作成時間がかかる場合はありますので、あらかじめご了承してください。'
        ]
      },
      {
        name: '<a href="http://www.justsystems.com/jp/download/ichitaro/ifilter/" target="blank">【一太郎】</a>',
        desc: [
          '一太郎13（試用版、正式版関係なく）をインストールした場合、IFILTERも同時インストールされます。ですので、一太郎13がインストールしていたPCに対して、別途上記Content Filterをインストール必要ありません。',
          '32ビットIFILTERですが、64ビットOSでもご利用可能です。'
        ]
      },
      {
        name: '<a href="https://support-fb.fujifilm.com/processDriverForm.do?ctry_code=SG&lang_code=en&d_lang=en&corp_pid=DWVL&rts=null&model=DocuWorks+Viewer+Light&type_id=3&oslist=Windows+10+64bit&lang_list=en" target="blank">【Docuwork】</a>',
        desc: [
          'Docuworks　8.0の場合、DocuWorks 8をインストールすると、同時にDocuWorks Content Filter 8もインストールされます。',
          'ですので、Docuworks　8.0がインストールしてあるPCに対して、別途Content Filterをインストール必要ありません。'
        ]
      }
    ],
    links: [
      { href: 'http://www.vector.co.jp/soft/winnt/util/se498053.html', label: 'Vector社検索ソフト集' },
      { href: 'http://download.seesaa.jp/contents/win/system/filer/16135/', label: 'Seesaa社検索ソフト集' },
      { href: 'http://download.goo.ne.jp/software/category/win/util/file/find/', label: 'Goo社検索ソフト集' },
      { href: 'http://ja.wikipedia.org/wiki/%E5%85%A8%E6%96%87%E6%A4%9C%E7%B4%A2#.E6.9C.89.E5.84.9F_2', label: 'Wikipediaー全文検索ソフト' },
      { href: 'http://download.nifty.com/download/win/util/file/find/', label: 'niftyー検索ソフト集' },
      { href: 'http://pdffreesoft.net/archives/pdf_search.html', label: '厳選！ＰＤＦフリーソフト' },
      { href: 'http://www.altech-ads.com/product/10008348.htm', label: 'World Soft' },
      { href: 'http://ansinsoft.com/', label: '安心ソフト' }
    ]
  },
  register: {
    name: '＊名前(必須）',
    mail: '＊メールアドレス(必須）',
    mail2: '＊メールアドレス（必須項目です、確認のため、もう一度入れてください）',
    company: '会社名',
    position: '役職',
    occupation: '職種',
    tel: '電話番号',
    purchaseDate: '＊購入日（必須）',
    licenseNo: '＊ライセンス番号（必須）',
    voice: 'ご要望',
    channel: 'どこからこの製品を初めに知りましたか',
    captcha: '＊下記表示されている画像の英文字を入れてください（必須）',
    captchaAlt: 'コード作成に失敗しました',
    refreshCode: '検証コードの更新',
    submit: '登録',
    reset: 'リセット',
    errEmail: 'メールアドレスが不正です',
    errEmailMatch: 'メールアドレスが相違です',
    errName: '名前が必須項目です',
    errMailRequired: 'メールアドレスを入力してください',
    errDateRequired: '購入日をいれてください',
    errLicRequired: 'ライセンス番号を入れてください',
    errLicInvalid: 'ライセンス番号不正です',
    errCaptcha: '検証コードを入れてください',
    errInvalid: '項目不正です、訂正してからサブミットしてください'
  },
  query: {
    loading: '読み込み中...'
  },
  mojiscan: {
    title: '文字スキャン (MojiScan)',
    heroBadge: '完全ローカル処理',
    tagline: '日本語OCRを、すべてローカルで。',
    subline: 'PDF・画像から日本語テキストを抽出。ファイルはアップロードされません。',
    heroNote: '体験版 {trialDays} 日間・1日 {trialPagesPerDay} ページまで（{price}）',
    introTitle: '実際の文書のためのOCR',
    introParagraphs: [
      '多くのOCRツールは、ページを「スキャン画像」か「検索可能」かのどちらかとして扱います。しかし実際の文書はもっと複雑です。テキストとして読めるヘッダーとスキャンした本文が混在していたり、署名ページが画像として貼り付けられていたり、以前のOCRレイヤーが残っていて誰も覚えていなかったりします。すべてにOCRをかけると、検索結果に同じ語が二重に表示されてしまいます。',
      'MojiScanは、そうした文書をPC上だけで処理します。既存のテキストはそのまま残し、古いOCRレイヤーは重ねずに書き換え、重複する行はスキップするため、検索結果に同じ語は一度しか表示されません。署名や印影の画像配置、テキストや図形の追加、回転、ページの抽出・分割、PDFの結合も同じ画面で行えます。MojiScan 2.1は、日本語と英語の検索可能な文書を、ファイルを外部に出さずに扱いたい方のためのWindowsツールです。30日間の無料トライアルもあります。'
    ],
    featuresTitle: '主な機能',
    featureCards: [
      {
        icon: 'el-icon-lock',
        title: '完全ローカル処理',
        desc: '処理はすべてお客様のパソコン上で実行されます。ファイルが外部へ送信されることはありません。'
      },
      {
        icon: 'el-icon-connection',
        title: 'オフラインOCR',
        desc: 'OCRエンジンと日本語モデルを同梱。インターネット接続なしでご利用いただけます。'
      },
      {
        icon: 'el-icon-search',
        title: 'Search++連携',
        desc: '全文検索くん（Search++）と連携し、抽出したテキストをそのまま全文検索できます。'
      },
      {
        icon: 'el-icon-document-add',
        title: '検索可能PDFの作成',
        desc: 'OCR の結果を、非表示のテキストレイヤー付き検索可能 PDF として保存できます。PNG・JPG・JPEG は PDF に変換してから保存します。'
      },
      {
        icon: 'el-icon-document-checked',
        title: '既存テキストを活かす',
        desc: 'PDF が元々持つテキストはそのまま保持。古い OCR レイヤーは書き換え、重複する OCR 行は追加しないため、検索結果で同じ語が重複しません。'
      }
    ],
    feature: '日本語OCR、PDF編集、合併、分割など操作をサポート、Search++と連携可能',
    featureList: [
      'PDF・PNG・JPG・JPEG の読み込み（ファイル選択またはドラッグ＆ドロップ）',
      'Markdown / TXT 出力、PDF・画像からの検索可能 PDF の作成（既存の PDF テキストは保持し、重複する OCR 行は追加しません）',
      '本文のどこまでが検索可能かを表示（ヘッダーやページ番号だけのページは別に数えます）',
      '既にテキストがある文書では OCR 実行前に確認し、保存時に元の PDF を上書きしません',
      'PDF の結合、ページ編集（回転・抽出・分割）、テキスト・画像の追加',
      '英語／日本語の UI 切り替え',
      '体験版 {trialDays} 日間（1 日 {trialPagesPerDay} ページまで）'
    ],
    disclaimer: '※本ソフトウェアは印刷された文書（活字）を主な対象とした OCR です。手書き文字・崩し字などは認識精度が著しく低下する場合があり、正確な変換は保証できません。',
    screenshotTitle: '画面例',
    screenshotAlt: 'MojiScan 画面例',
    screenshotPlaceholder: '（スクリーンショット準備中）',
    priceTitle: '価格',
    priceLine: '{price}（体験版 {trialDays} 日間あり）',
    price: '3,410円（税込）',
    downloadTitle: 'ダウンロード',
    downloadDesc: 'Windows 10/11（64-bit）向けスタンドアロン版。ZIP を展開後、<strong>MojiScan.exe</strong> を実行してください。',
    downloadLink: 'MojiScan (Version {version}) ダウンロード ({zipName})',
    faqTitle: 'よくある質問（FAQ）',
    faqItems: [
      {
        q: '支払い後、ライセンスキーはどのように届きますか？',
        a: 'お支払い完了後、ライセンスキーをメール等でお届けします。'
      },
      {
        q: 'ライセンスキーはどこで使いますか？',
        a: 'アプリの「ライセンス」ダイアログにキーを入力し、オンライン認証を行ってください。'
      },
      {
        q: '1つのライセンスで複数のPCで使えますか？',
        a: '1ライセンスは1台のPCでのみ利用できます。'
      },
      {
        q: 'OCRの認識精度はどのくらいですか？',
        a: '印刷された文書（活字）を主な対象としています。手書き文字・崩し字などは認識精度が低下する場合があり、正確な変換は保証できません。重要な文書は必ず内容をご確認ください。'
      },
      {
        q: 'スキャンした PDF を検索可能にできますか？',
        a: 'はい。OCR を実行し「テキストレイヤー付き PDF として保存」を選ぶと、非表示のテキストレイヤー付きで検索・コピーできる PDF になります。PNG・JPG・JPEG は PDF に変換してから保存します。'
      },
      {
        q: '既にテキストが入っている PDF に OCR をかけるとどうなりますか？',
        a: 'そのテキストは保持されます。非表示の OCR レイヤーは積み重ねずに書き換え、ページが既に持つテキストと重複する OCR 行は追加しないため、検索結果で同じ語が重複しません。保存前に内容を示すダイアログが表示され、元の PDF は上書きされません。'
      },
      {
        q: '返品・返金はできますか？',
        a: 'ダウンロード型商品のため返品・返金には応じかねます。30日間の体験版（1日50ページまで）で十分にご確認のうえご購入ください。'
      }
    ],
    sellerTitle: '返品・販売者情報',
    sellerInfo: [
      '販売元：Search++（お問い合わせ：searchkun@gmail.com）',
      'お支払い方法：Stripe（クレジットカード）',
      'ライセンスキーのお届け：お支払い完了後、メール等でお送りします（通常24時間以内）',
      '返品・返金：ダウンロード型商品のため返品・返金には応じかねます。購入前に体験版（30日間）でご確認ください。'
    ],
    manualTitle: 'マニュアル',
    manualJa: 'ユーザーガイド（日本語）',
    manualEn: 'User Guide (English)'
  },
  bookmarksearch: {
    title: 'ブックマーク検索 (BookMarkSearch)',
    heroBadge: '完全ローカル処理',
    tagline: 'ブックマークと履歴の検索を、すべてローカルで。',
    subline: 'ブックマークをタイトル・URL・本文から全文検索。閲覧履歴にも対応。ファイルはアップロードされません。',
    heroNote: '体験版 {trialDays} 日間（{price}）',
    featuresTitle: '主な機能',
    featureCards: [
      {
        icon: 'el-icon-lock',
        title: '完全ローカル処理',
        desc: 'ブックマークファイルはローカルのみで読み込まれます。外部へ送信されるのは、検索結果から開いた URL だけです。'
      },
      {
        icon: 'el-icon-link',
        title: '主要ブラウザ対応',
        desc: 'Chrome・Edge・Brave のブックマークと閲覧履歴を自動検出。HTML 書き出しファイルもインポートできます。'
      },
      {
        icon: 'el-icon-search',
        title: 'ページ本文まで検索',
        desc: 'タイトル・URL・フォルダ・ソースに加え、ダウンロードしたページ本文も全文検索できます。'
      },
      {
        icon: 'el-icon-time',
        title: '閲覧履歴も検索',
        desc: 'Chrome・Edge・Brave の閲覧履歴を、タイトルと URL でブックマークと同じように検索できます。'
      }
    ],
    feature: 'ブラウザのブックマークと閲覧履歴をタイトル、URL、フォルダ、ページ本文から全文検索。Search++シリーズ。',
    featureList: [
      'タイトル、URL、フォルダパス、ソース、ダウンロードしたページ本文を全文検索',
      'Chrome / Edge / Brave の閲覧履歴もタイトルと URL で検索',
      'Chrome / Edge / Brave のブックマークを自動検出、HTML 書き出しファイルもインポート可能',
      '検索結果をダブルクリックで既定のブラウザで開く',
      '体験版 {trialDays} 日間（全機能試用可）'
    ],
    disclaimer: '※ページ本文の検索には、インデックス再構築時に各ページのダウンロードが必要です。アクセスできないページは本文が検索対象外となります（タイトル・URL・フォルダ名は常に検索対象です）。',
    screenshotTitle: '画面例',
    screenshotAlt: 'BookMarkSearch 画面例',
    screenshotPlaceholder: '（スクリーンショット準備中）',
    priceTitle: '価格',
    priceLine: '{price}（体験版 {trialDays} 日間あり）',
    price: '3,410円（税込）',
    downloadTitle: 'ダウンロード',
    downloadDesc: 'Windows 10/11（64-bit）向けスタンドアロン版。ZIP を展開後、<strong>BookMarkSearch-{version}.exe</strong> を実行してください。',
    downloadLink: 'BookMarkSearch (Version {version}) ダウンロード ({zipName})',
    faqTitle: 'よくある質問（FAQ）',
    faqItems: [
      {
        q: '対応しているブラウザは？',
        a: 'Chrome・Edge・Brave のブックマークファイルと閲覧履歴を自動検出します。Netscape/HTML 形式の書き出しファイルもインポートできます。'
      },
      {
        q: 'ブックマークや検索内容は外部に送信されますか？',
        a: 'いいえ。ブックマークおよび閲覧履歴はローカルでのみ読み込まれます。外部へ送信されるのは、検索結果から開いた URL のみです。'
      },
      {
        q: 'ページ本文の検索には何が必要ですか？',
        a: '「インデックス再構築」時に各ページをダウンロードして本文をインデックスします。ダウンロード結果はキャッシュされ、2回目以降は高速です。'
      },
      {
        q: '1つのライセンスで複数のPCで使えますか？',
        a: '1ライセンスは1台のPCでのみ利用できます。'
      },
      {
        q: '返品・返金はできますか？',
        a: 'ダウンロード型商品のため返品・返金には応じかねます。30日間の体験版で十分にご確認のうえご購入ください。'
      }
    ],
    sellerTitle: '返品・販売者情報',
    sellerInfo: [
      '販売元：Search++（お問い合わせ：searchkun@gmail.com）',
      'お支払い方法：Stripe（クレジットカード）',
      'ライセンスキーのお届け：お支払い完了後、メール等でお送りします（通常24時間以内）',
      '返品・返金：ダウンロード型商品のため返品・返金には応じかねます。購入前に体験版（30日間）でご確認ください。'
    ],
    manualTitle: 'マニュアル',
    manualJa: 'ユーザーガイド（日本語）',
    manualEn: 'User Guide (English)'
  },
  faq: {
    title: 'FAQ',
    queryButton: '問い合わせフォーム',
    items: [
      {
        id: '1',
        question: 'ダウンロード途中で、「一般的にダウンロードされておらず危険を及ぼす可能性があります」というような警告が出て ダウンロードを中止するように勧告が表示されましたが、どのようにすればいいでしょうか？',
        answer: [
          'この警告はブラウザ自体のセキュリティ の関係上出現してしまうものです。全文検索くんソフトウェア自体はウィルス検査もパスしており、 有害なソフトウェアではございませんので、この警告に対して「継続」と答えれば、ファイルを ダウンロードしていただけます。',
          'Windows 10で実行する場合、「WindowsよりPCが保護されました、Windows SmartScreenは認識されないアプリの起動を停止しました。このアプリを起動すると、 PCに問題が起こる可能性があります。詳細情報」とのメッセージが出たら、Windows10の誤報です、詳細情報をクリックして、実行してください。'
        ]
      },
      {
        id: '2',
        question: 'インストールフォルダーについて',
        answer: [
          'インストールフォルダーについて、インストールフォルダーについて、C:\\Program Files, C:\\Program Files(X86)に入れないでください。（権限の問題で動かなくなる可能性がある）',
          'C:\\Program Files\\SearchPlusPlus（✖）',
          'C:\\SearchPlusPlus（〇）',
          'D:\\SearchPlusPlus（〇）',
          'Zip ファイルを展開する際、”展開フされたァイルがありません”のようなエラーメッセージが出た或はZip展開した後 SearchPlusPlus.exe を起動させようと、”Could not find Java SE Environment”のようなエラーメッセージが出た場合、OS のコード設定不正と考えられます。下記質問６)の回答通りにOS のコードを日本語に設定し直すか、全文検索くんのインストールフォルダー名に日本語を使用しないか（例えば： C:\\SearchPlusPlus またはD:\\SearchPlusPlus にインストールする）によって、問題が解決できます。'
        ]
      },
      {
        id: '3',
        question: '検索キーワードについて',
        answer: [
          '入力した検索語に対して、キーワードの分析処理（Keyword Parsing）をしてから検索をかけます、検索キーがいずれ存在すれば、そのファイルを検出します。',
          '検索語をダブルクォーテーションで括る場合、上記分析処理をせず、検索語をひとつ検索単位とします、一部の単語だけが存在しているファイルはヒット対象になりません',
          'ですから、人名、地名で検索する場合、ひとつの検索単位として、半角ダブルクォーテーションで括って検索してください。例えば、中村一郎を検索する場合、"中村一郎"で検索欄に記述してください。'
        ]
      },
      {
        id: '4',
        question: '社内ネットワーク上のファイルを検索可能ですか',
        answer: [
          '可能です。シェアフォルダをネットワークドライブに割り当てたら、普通に検索できます。',
          'オプション画面のインデックス対象指定画面で割り当て機能があります。'
        ]
      },
      {
        id: '5',
        question: '検索キーワードについて',
        answer: [
          '入力した検索語に対して、キーワードの分析処理（Keyword Parsing）をしてから検索をかけます、検索キーがいずれ存在すれば、そのファイルを検出します。'
        ]
      },
      {
        id: '6',
        question: 'インデックスデータの自動更新機能がありますか',
        answer: [
          '常駐モードでは、対象フォルダを監視して、変更があれば、対象となるものに対してインデックスデータを自動更新します。'
        ]
      },
      {
        id: '7',
        question: '文字化けの防止',
        answer: [
          'コントロールパネルで「形式」・「現在の場所」・「現在のシステムロケール」以上３か所を「日本語」・「日本」に設定してください。'
        ]
      },
      {
        id: '8',
        question: 'サブフォルダを検索対象外とする機能がありますか',
        answer: [
          'オプション画面でファイルの拡張子設定により特定タイプのファイルを排除することが可能です。同じく、フォルダ選択画面でサブフォルダの排除も可能です'
        ]
      },
      {
        id: '9',
        question: 'ホットキーがありますか',
        answer: [
          'ホットキーで検索のメーン画面を呼び出すことがあります。ホットキーについて、「オプション」画面で設定可能です。',
          'しかし、Adobe Readerの保護モード設定によって、ホットキーがブロックされた場合があります。',
          '保護モードを外す方法はAdobe Readerのバージョンによって違います',
          'Reader X以下では「編集」メニュー>「環境設定」の「一般」タブを選んで、「起動時に保護モードを有効にする」をオフにする。',
          'Reader XIでは「編集」メニュー>「環境設定」の「セキュリティ（拡張）」タブを選んで、「サンドボックスによる保護」領域で、「起動時に保護モードを有効にする」をオフにします。'
        ]
      },
      {
        id: '10',
        question: 'インストール・アンインストール機能がありますか',
        answer: [
          '全文検索くん標準版ではレジストリの変更がないくて、ZIPファイルを解凍すれば結構です',
          'Pro版では、Windows　GDIの設定を変えるだけで、ZIPファイルを解凍して、Startup.exeを実行していただきたい',
          'アンインストールはそれぞれ同梱のDelete.exeまたはUnistall.exeを実行してください'
        ]
      },
      {
        id: '11',
        question: '縦書きPDFの検索できますか',
        answer: [
          '縦書きPDFの検索が可能です',
          '下記の手順で実現が可能です。',
          '1) 縦書きPDFをサポートするメーカーサイトから使用条件を確認したうえ、下記IFILTERをインストールしてください。',
          '<a href="http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611">http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611</a>',
          '(WindowsXP以降で全文検索くんとの連動に問題ないと確認済み)',
          '2) 全文検索くんを起動していない状態を確認します。',
          '右下のトレー領域に全文検索くんのアイコンがないかCtrl+Shiftで全文検索くん の検索画面がでないかを確認します。アイコンがあるまたは Ctrl+Shiftで検索 画面が出たら、全文検索くんは 起動している状態で、まず、停止させてください。',
          '停止させる方法は、全文検索くんのメイン画面の左側の「その他機能」→「終 了」を押せば、停止できます',
          '3) 下記サンプルのように、全文検索くんのインストールフォルダーのtoolフォルダー下にあるconfig.xmlに下記の一行を追加します。',
          '&#60;IFilter.pdf&#62;1&#60;/IFilter.pdf&#62;',
          '4）インデックスを再作成していただければ、検索できるようになります。'
        ]
      },
      {
        id: '12',
        question: '複数台のPCをご利用していますが、ライセンスの共用が可能でしょうか',
        answer: [
          'すみませんですが、PC単位のライセンス形態です。',
          'ライセンスのシェアができないです',
          '複数台PCでのご利用であれば、台数分のライセンスキーが必要です'
        ]
      },
      {
        id: '13',
        question: '全文検索くんメーン画面に表示したホームページが古いようですが、どのようにすれば最新ページを表示できるでしょうか',
        answer: [
          'Windowsのコントロールパネルのインタネットオプション画面でヒストリ―を削除すれば、ローカルPCのキャシューがなくなり、最新版が表示できるようになります。'
        ]
      },
      {
        id: '14',
        question: '全文検索くんZIP版をダウンロードして実行して、インデックス作成もできて、検索も問題ないですが、OS再起動すると、全文検索くん再起動できない、どのようにすればいいでしょうか',
        answer: [
          '全文検索くんZIP版をダウンロードしたら、必ずフォルダを指定して展開してください。OSのデフォルト処理で、ダウンロードしたZIPファイルを開くことになります。そのままZIPファイル中のSearchplusplus.exeをクリックして実行できても、そのあと、OS再起動すると、一時ファイルは削除されて、ご利用できないです。なので、初心者に対して全文検索くんインストール版をご利用することを推薦します。'
        ]
      }
    ]
  },
  voc: {
    voices: [
      {
        id: '1',
        name: 'ひろさん様',
        color: 'color:Violet',
        subTitle: ['全文検索ソフトでは最高峰の出来！'],
        voice: [
          '全文検索ソフトでは最高峰の出来！',
          '仕事で、大量の文書から過去の記述を検索する必要があり、これまで様々な全文検索ソフトを試してきました。どれも一長一短あって、なかなか満足のいくものに出会えなかったのですが、とうとう巡り会いました！このソフトは、私の考えうる要望を全て満たしています。もう、手放せません。加えて、ユーザーへの対応も丁寧！'
        ]
      },
      {
        id: '2',
        name: 'a-natsuki様',
        color: 'color:Violet',
        subTitle: ['知る限り今Windows8で数少ない「店売りのネットワークドライブ上のファイルを対象に全文検索可能」なソフトです'],
        voice: [
          '知る限り今Windows8で数少ない「店売りのネットワークドライブ上のファイルを対象に全文検索可能」なソフトです。',
          '何故かwindowsサーチは７→8になって検索対象から「Windows8以外でたてられたネットワークドライブ」を外してしまい、よく売っているようなLinaxベースのネットワークドライブの中が検索できなくなっていたので、このソフトがなかったらWindows7のOSを買うことになっていたでしょう。もし出来るならばインデックスの作製がやっぱり時間がかかるので、時間指定でインデックス更新ができれば最高です。'
        ]
      },
      {
        id: '3',
        name: '電子ブックナビ様',
        color: 'color:Violet',
        subTitle: ['Google desktopがなくなって、困った時、このソフトを見つけて、良かった。'],
        voice: [
          '自炊したPDFにOCRをかけて情報の検索に使われている方も多いと思います。探している単語で検索してくれるので大変便利ですが、ファイルを一旦開かないと検索できないため、どのファイルに載っているか分からない時や全部のファイルを検索したい時には困ってしまいます。以前はGoogle desktopがサポートされていたのでそれを使っていましたが、提供されなくなって困っていらっしゃる方も多いと思います。',
          'そんな時に役立つツール「全文検索くん（Search++）を紹介します。',
          '「全文検索くん（Search++）」インデックス型全文検索ツールです。ファイルが保管されてるフォルダを指定するとファイルの内容（OCRテキスト付PDFの場合はテキスト）をインデックス化してくれますので、複数のファイルから検索語を見つけて表示してくれます。',
          'ドライブを割り当てると、ネットワーク上のフォルダも対象になりますので、LANDISKに入れたファイルも検索してくれます。'
        ]
      },
      {
        id: '4',
        name: 'はな様',
        color: 'color:Blue',
        subTitle: ['翻訳会社から大量の資料が送られてくることがあります、そんなとき「全文検索君(Search++)」を使っています。かなり重宝しています。'],
        voice: [
          '翻訳するにあたって翻訳会社から大量の資料が送られてくることがあります。',
          '今回の案件はかなり大規模な医療機器で附属機器もたくさんありそれぞれに添付文書があります。機器の前のバージョンの添付文書が参考資料として送られてきて、わからない訳語があるたびに旧添付文書で該当箇所（とそれに近いところ）を読んで言葉をさがしたりあたりをつけます。資料がたくさんあると探すのも大変、、、、。',
          'Windowsの検索機能もありますが、PDFの中身についてはできません。 そんなとき「全文検索君(Search++)」を使っています。初期設定で検索場所を指定でき、キーワード検索をかけるとそのキーワードの記載がある文書がウィンドウの左側に全てリストアップされ、掲載場所の抜粋が右側に併記されます。',
          '検索も早いのでかなり重宝しています。 翻訳以外にも「○○についての資料があった気がするけどどの文書がわかんー」というときにも使えて便利です。'
        ]
      },
      {
        id: '5',
        name: 'Jinzai_3様',
        color: 'color:Blue',
        subTitle: ['紙の情報はスキャナーで読み込みパソコン内に多数保管しています、全文検索くんは必要な情報を簡単に読み出せるため大変助かっています。'],
        voice: [
          'ファイル名検索ソフトは多数ありますが、そのほとんどは「内容検索」が出来ません。本ソフトは多数のファイル形式（拡張子）に対応した「ファイル内文字検索」が出来るので、パソコン内に保管している自分が作成したファイルやダウンロードした各種情報の検索に大変重宝しています。',
          '私は紙の情報はスキャナーで読み込みパソコン内に多数保管しています。このOCRソフトはあるメーカーのDocuWorksを使用しています（多数の企業等で使用しています）。このたび全文検索くんVer.2.8.2からこのDocuWorks文書（拡張子.xdw）も検索可能になり、必要な情報が簡単に読み出せるため大変助かっています。皆様も是非どうぞ。'
        ]
      },
      {
        id: '6',
        name: 'osumi-jimusyo様',
        color: 'color:Blue',
        subTitle: ['縦書きや横書きの大量のPDF資料の中から目的のファイルを素早く探すことができて、とても便利です。'],
        voice: [
          '縦書きや横書きの大量のPDF資料の中から目的のファイルを素早く探すことができて、とても便利です。',
          'ビアクロバットの検索は一回一回ものすごく時間がかかる上、その確認もたいへんでしたが、このソフトはクリック一つで検索結果内容を素早く確認できたり、そのファイルを開いたり、とても使いやすくできていて大満足です。これまでいくつも検索ソフトを試してみましたが最も良いソフトです。',
          'サポートもとても親切・丁寧で嬉しい限りです。'
        ]
      },
      {
        id: '7',
        name: 'てつ様',
        color: 'color:Black',
        subTitle: ['部品カタログや取扱説明書を一瞬で検索ができるので助かります、一ヶ月じっくり試用してから購入しました。'],
        voice: [
          '仕事柄、メーカーの部品カタログや取扱説明書をPDFでたくさん使わなければならないのですが、これらのファイル名はたいていメーカ独自の通し番号などで後からどれがどのファイルだったかわかりにくいものです。 かといってファイル名を変えてしまうと頻繁に改訂があるため自分の持っているものが最新かどうか分かりづらくなってしまいます。 adobe readerやPDF Xchangeにはフォルダ内からの検索機能がありますが、フォルダ指定が面倒なのと毎回検索のため非常に時間がかかっていました。 他の検索ソフトもgrep系は毎回検索で、データベース化を謳っているものも一度検索したキーワードについてのみでした。 このソフトは本当に一瞬で検索ができるので助かります。 また、サポートもしっかりしていて信頼できます。 一ヶ月じっくり試用してから購入しました。'
        ]
      },
      {
        id: '8',
        name: 'haruka1971様',
        color: 'color:Black',
        subTitle: ['翻訳の仕事で、ほかのツールと比べる、内容検索力、キーワードハイライト機能などが優れています'],
        voice: [
          '私は翻訳の仕事をしておりますが、英語、日本語のキーワードでファイル検索は日常作業によくあることです、ほかのツールと比べる、内容検索力、キーワードハイライト機能などが優れています。作業にかかる時間が大幅に短縮できました。ほんとうに助かりました。'
        ]
      },
      {
        id: '9',
        name: 'ti2013様',
        color: 'color:Black',
        subTitle: ['Search++は、やっと出てきた有り難いソフトです'],
        voice: [
          'Windows Desktop searchはXP以降、検索能力がダメになりました。 Win7 の検索は賛否分かれているような感じですが、私のPCでは全然ダメです。 Search++は、やっと出てきた有り難いソフトです。'
        ]
      }
    ]
  },
  release: {
    title: '更新履歴',
    colTime: '時間',
    colVer: 'バージョン',
    searchPlaceholder: '検索キーワードを入力してください',
    items: [
      {
        time: '2026年9月28日',
        ver: 'BookMarkSearch V1.1.0',
        update: [
          'ブックマーク検索（BookMarkSearch）V1.1.0をリリース',
          '閲覧履歴検索を追加：Chrome・Edge・Brave の閲覧履歴を、タイトルと URL でブックマークとあわせて検索できるようになりました'
        ]
      },
      {
        time: '2026年9月17日',
        ver: 'MojiScan V2.1',
        update: [
          '文字スキャン（MojiScan）V2.1をリリース',
          '検索可能 PDF の保存時に、PDF が元々持つテキストはそのまま残し、重複する OCR 行を追加しないようにしました（検索結果で同じ語が重複しません）',
          'ステータスバーに本文テキストの割合を表示するようにしました（ヘッダーやページ番号だけのページは検索可能として数えません）',
          '画像ファイルからも検索可能 PDF を保存できるようにしました',
          '検索可能 PDF の保存前に、既存テキストをどのように扱うかを示すダイアログを表示するようにしました',
          '既にテキストがある PDF では OCR 実行前に確認し、元の PDF を上書きしないようにしました'
        ]
      },
      {
        time: '2026年9月12日',
        ver: 'MojiScan V2.0',
        update: [
          '文字スキャン（MojiScan）V2.0をリリース'
        ]
      },
      {
        time: '2026年8月24日',
        ver: 'V6.2.1.3',
        update: [
          '標準版・Pro版のインデックス作成速度を改善'
        ]
      },
      {
        time: '2026年8月21日',
        ver: 'MojiScan V1.1 / BookMarkSearch V1.0.0',
        update: [
          '文字スキャン（MojiScan）V1.1とブックマーク検索（BookMarkSearch）V1.0.0をリリース'
        ]
      },
      {
        time: '2026年8月7日',
        ver: 'MojiScan V1.1',
        update: [
          '文字スキャン（MojiScan）V1.1をリリース'
        ]
      },
      {
        time: '2026年7月4日',
        ver: 'V6.2.1.2',
        update: [
          '標準版もPro版も、起動時に前回終了時のウィンドウ位置・サイズを復元する',
          '日本語OCR・PDF編集ツール「文字スキャン（MojiScan）」V1.0をリリース'
        ]
      },
      {
        time: '2026年4月17日',
        ver: 'V6.2.1.1',
        update: [
          'オアシスのファイル（*.OAS）をサポートする',
          '初期画面から検索画面へレイアウト変換の障害対応'
        ]
      },
      {
        time: '2026年2月26日',
        ver: 'V6.2.1.0',
        update: [
          'Windows 10/11のため、レイアウトの更新',
          '白・黒のカラーテーマの再実装'
        ]
      },
      {
        time: '2025年12月30日',
        ver: 'V6.2.0.0',
        update: [
          'Windows 10/11のため、UIレイアウトを調整しました',
          'Javaを含め各モジュールのバージョンアップにより、性能改善ができました'
        ]
      },
      {
        time: '2023年8月20日',
        ver: 'V6.1.1.2-従来UI版',
        update: [
          'インデックス作成処理モジュールのバージョンアップにより、作成時間の短縮ができました'
        ]
      },
      {
        time: '2022年10月12日',
        ver: 'V6.1.1.1-WebUI版',
        update: [
          'ページ番号の表示を作り直しました',
          '左側のレイアウトを変更、ページネーションを上部に配置しました',
          '左側のレイアウトを変更、ボタン欄をなくして、ファイルの傍に配置しました',
          '右側のテキスト表示欄に右クリックするとポップアップメニューを表示します'
        ]
      },
      {
        time: '2022年7月11日',
        ver: 'V6.1.1.0',
        update: [
          '標準版もPro版も前方一致検索とキーワード検索併用可能。例えば「Search*　画面」で検索可能',
          'Pro版、WebUI版、標準版に色テーマの設定が可能（インデックスメニューのオプション設定サブメニュー→画面設定タブでカラーテーマは白、黒の切り替えが可能）',
          'WebUI版に対して、検索履歴をプルダウンリストから表示するように変更',
          'WebUI版に対して、ファイル名と概要内容を一コラムに表示する'
        ]
      },
      {
        time: '2022年3月11日',
        ver: 'V6.1.0.9',
        update: [
          '標準版もPro版も前方一致検索ができた。検索語に*をつけて例えば300*で検索可能',
          'Pro版に色テーマの設定が可能（インデックスメニューのオプション設定サブメニュー→画面設定タブでカラーテーマは白、黒の切り替えが可能）',
          'Pro版の反転処理も改善した'
        ]
      },
      {
        time: '2022年1月26日',
        ver: 'V6.1.0.8',
        update: [
          '最新ウェブ技術を使ったPro版のUIを作り直した。そのため、Pro版のご利用はWindows7以上64ビットOSだけになります'
        ]
      },
      {
        time: '2021年4月2日',
        ver: 'V6.1.0.7',
        update: [
          'インデックス更新処理をWindowsサービスとして登録し、ログインしなくても、インデックス更新できます。この機能は社内検索システム構築時にエージェント側だけ利用できます。'
        ]
      },
      {
        time: '2020年12月24日',
        ver: 'V6.1.0.6',
        update: [
          '各ダイアログを再作成して、ディスプレーフォントのサイズに対応できました。',
          '標準版のWindows XPの場合、オプション画面が表示できない問題を解消しました。',
          '一部検索語の近傍検索で「ヒットしても反転しない」障害の対応。',
          '新HPのリリース'
        ]
      },
      {
        time: '2020年6月10日',
        ver: 'V6.1.0.5',
        update: [
          'インデックス作成速度の向上ー利用可能メモリに応じてインデックス作成処理の最適化',
          '標準版についてメモリツールに利用可能な最大値チェックを入れた',
          'MAC　OS上の改行コード（"\r"）を対応した'
        ]
      },
      {
        time: '2020年4月26日',
        ver: 'V6.1.0.4',
        update: [
          '「テキスト」、「抜粋」、「該当行」ビューどれかを選択したら、その状態を保ちます、ファイルをクリックすると、選択されたビューで表示するように実装した',
          '右側のビューで単語を選択して「検索し直す」機能を実装した',
          'ネットワークドライブの割りあて機能を実装した',
          'インデックス作成、検索時プログレスバーを表示するようにした',
          '障害対応: ツールバーにある絞込むボタンを押すと検索対象に対して絞り込むが可能'
        ]
      },
      {
        time: '2020年3月19日',
        ver: 'V6.1.0.3',
        update: [
          '検索結果からさらに絞込む機能の実装'
        ]
      },
      {
        time: '2019年12月1日',
        ver: 'V6.1.0.2',
        update: [
          'プレビュー機能の改善、スピードの向上',
          '拡張子とともに「検索対象外」にファイルの指定も可能',
          '「再作成」チェックが入ったインデックスグループだけを「インデックス再作成」対象にする。（退避されたインデックスグループを再作成の対象外にする）',
          '設定ファイル（Config.xml）にSynonymを追加、1の場合は類似語検索機能が有効にする、0の場合は類似語検索機能が無効にする。<Synonym>0</Synonym>'
        ]
      },
      {
        time: '2019年10月10日',
        ver: 'V6.1.0.1',
        update: [
          'インデックスデータ量を減らすため、データ構造の変更',
          '検索と反転の表示速度を向上させる'
        ]
      },
      {
        time: '2019年6月3日',
        ver: 'V6.1.0.0',
        update: [
          '大きいファイルの表示について性能改善',
          'PSTファイルのインデックスデータ作成に作った一時ファイルの削除',
          'メイン画面のインデックス名にフォルダー情報の表示',
          'UIの改善',
          'MacOS版の更新（7月28日）'
        ]
      },
      {
        time: '2019年1月8日',
        ver: 'V6.0.0.1',
        update: [
          '新しいUI：新しいデザインアイコンなど',
          '色の管理：テキスト色、バックグランド色、反転色の設定は可能',
          'Java バージョンの更新',
          'プレビュー機能のバグ修正',
          'テーブルヘーダの表示・非表示',
          'ユーザ辞書のサポート(標準版もPro版も)'
        ]
      },
      {
        time: '2018年11月9日',
        ver: 'V6.0.0.0',
        update: [
          'MAC OSバージョンのリリース',
          '複合語をサポートする近傍検索',
          'ユーザ辞書のサポート',
          'ホットキーでメイン画面を呼ぶ機能のバグ修正:誤動作の防止',
          'コピー・移動・削除処理バグの修正',
          '面画面の上部レイアウトの調整:一部のOSで検索テキストボックスが隠さないようにポジションを調整した'
        ]
      },
      {
        time: '2018年8月12日',
        ver: 'V5.0.0.1',
        update: [
          '類似語の検索ができました。この機能のご利用には、インターネットへ接続が必要、この機能を無効にするには、設定ファイルConfig.xmlに下記一行を追加すれば結構です<Synonym>70</Synonym>'
        ]
      },
      {
        time: '2018年7月20日',
        ver: 'V5.0.0.0',
        update: [
          '右クリックメニューで「テキスト」ビュー、「抜粋」ビュー、「該当行」ビューへお互いに遷移できるようにしました',
          '右クリックメニューで「テキスト」ビュー、「抜粋」ビュー、「該当行」ビューへお互いに遷移する時、カレント行をマークできるようにしました',
          'マシンの解像度をチェックして、タブレットであれば、UIを自動調整できるようにしました',
          'メールファイル（MSGファイル、EMLファイル）の場合、ファイル日付ではなくメール送信日付が表示され、絞り込み検索できるようにしました'
        ]
      },
      {
        time: '2018年2月16日',
        ver: 'V4.0.0.10',
        update: [
          'PSTファイルの検索が可能',
          'オプション画面で、対象ファイルタイプ、排除対象ファイルタイプをダイアログで選択して設定できるようにしました'
        ]
      },
      {
        time: '2017年10月25日',
        ver: 'V4.0.0.9',
        update: [
          'ファイルプレビュー機能の実現',
          'プレビューウィンドウで右マウスで「縮小」、「拡大」、次のページ、前のページを実装',
          '利用メモリ設定ツールの障害対応'
        ]
      },
      {
        time: '2017年9月1日',
        ver: 'V4.0.0.8',
        update: [
          'ファイル共有機能の実現',
          'HTTPサーバーの実現',
          'ウェブ検索機能を付けました。一つボタンで、Bing・Google・Wiki・Yahooで入力したキーワードで検索できます'
        ]
      },
      {
        time: '2017年5月30日',
        ver: 'V4.0.0.7',
        update: [
          '最近使用したファイルリストをダブルクリックすると、メイン画面に遷移します',
          '最近使用したファイルリストをクリアできるようにしました',
          '上下の矢印キーで検索ワード履歴を選択すると、テキストボックスの内容を更新させる',
          '検索キーワード履歴をクリアできる'
        ]
      },
      {
        time: '2017年4月11日',
        ver: 'V4.0.0.6',
        update: [
          '絞り込み条件は一旦設定したら、クリアボタンが押されるまで保持します、それからの検索に、この条件を適用するように実装追加',
          '最近使用したファイルリスト一覧を実装した',
          '高い解像度に対応するオプションを追加した'
        ]
      },
      {
        time: '2017年3月16日',
        ver: 'V4.0.0.5',
        update: [
          'プレビューの速度を改善',
          'ファイル名検索の速度を改善',
          'インデックス作成の速度を改善'
        ]
      },
      {
        time: '2017年2月17日',
        ver: 'V4.0.0.3',
        update: [
          'ファイル名検索のインクリメント検索を実装した',
          'ファイル名検索の結果をアンダーラインで表示する',
          'アンインストールする際、認証を自動解除するように実装した'
        ]
      },
      {
        time: '2016年11月30日',
        ver: 'V4.0.0.2',
        update: [
          '個別インデックスを指定して再作成する',
          'インデックスデータ保存場所が外付けHDの場合、差し抜けによってドライブが変わっても、検知できて、自動的にインデックスデータフォルダを設定し直すこと',
          'フォルダー指定して絞り込む検索機能',
          'ホットキーを押すと、前回の検索結果をクリアする'
        ]
      },
      {
        time: '2016年11月9日',
        ver: 'V4.0.0.1',
        update: [
          'インデックスの退避・復活機能',
          'ステータスバーに検索時間を表示する'
        ]
      },
      {
        time: '2016年10月1日',
        ver: 'V4.0.0.0',
        update: [
          '検索結果リストにページをつける、ページサイズの設定、ページ遷移する機能を実装した、これにより、検索結果リストの表示行数は何万までも可能',
          '検索結果リストの高さを動的に調整できるように実装した',
          'ファイル名の全文検索を実装した',
          'ツールバーボタンの状態を表示するようにした',
          '参考資料の追加：社内検索システム構築図 https://www.searchplusplus.jp/Agent_Client.pdf'
        ]
      },
      {
        time: '2016年8月10日',
        ver: 'V3.2.2.6',
        update: [
          '検索機能の改善： いままでの変化形を一緒に検索するモードに入力語とぴったり一致する検索モードも実現しました。デフォルトはぴったり一致するモードにした。変化形を一緒に検索するモードへ切り替えるにはConfig.xmlに下記一行を追加する<Lem>0</Lem>',
          '複数検索語の場合、演算方法をANDかORかに指定できる',
          '複数インデックス設定画面に追加、削除、リセットアイコンを追加した',
          'インデックスデータフォルダー及びソフトウェアのインストールフォルダへの書き込み権限あるかどうかをチェックするように実装した',
          '「ユーザへのお知らせ」ダイアログをカスタマイズした（最新版はベクター社にリリース依頼中ですが、このサイトからダウンロードできます）'
        ]
      },
      {
        time: '2016年6月18日',
        ver: 'V3.2.2.5',
        update: [
          '一太郎IFILTERのフォントメッセージ問題を解決ため、FILTERを利用せず一太郎ファイル(.jtd)の解析を実現'
        ]
      },
      {
        time: '2016年3月25日',
        ver: 'V3.2.2.4',
        update: [
          'UIの改善:ビューモード状態の表示',
          '認証機能の改善：プロキシサーバーを設定できるようにした',
          'ステータスバーで、インデックスデータ作成時の進捗表示位置の調整',
          '異常終了の時、設定ファイルの自動バックアップと自動リストア'
        ]
      },
      {
        time: '2016年2月15日',
        ver: 'V3.2.2.3',
        update: [
          '検索結果リストアイコンなど表示調整',
          'インストール･アンインストールプログラム機能増強',
          'インデックス作成時、進捗（％）をステータスバーで表示する',
          '一つインスタンスの機能実装：Searchplusplus.exeを二回起動させると、一回目時の画面を表示する',
          'バグ修正:',
          '        ：排除フォルダの設定',
          '        ：インデックスを自動更新後の検索'
        ]
      },
      {
        time: '2016年1月15日',
        ver: 'V3.2.2.2',
        update: [
          'OSからDrag&Dropで検索対象フォルダー設定できるようにした　',
          'ネットワーク認証・解除機能の実現',
          'お知らせ機能の実装'
        ]
      },
      {
        time: '2015年10月23日',
        ver: 'V3.2.2',
        update: [
          '反転処理をより判りやすくした',
          '各ビューでキーワードを反転表示できるようにした',
          '英語の単数・複数検索できるようにした',
          '日本語の動詞活用形検索できるようにした',
          '「前のキーワード」ボタンを実装した',
          '障害対応'
        ]
      },
      {
        time: '2015年9月26日',
        ver: 'V3.2.1',
        update: [
          '複数インデックスデータの作成が可能',
          'インデックス作成時、大きいファイルに対してめもり足りない場合、下記メッセージが出ますが、１０秒以上経つと自動的にスキップして処理が続きます',
          '非常駐モードで検索する時のメッセージに「今後表示しない」オプションを付けます'
        ]
      },
      {
        time: '2015年6月21日',
        ver: 'V3.1.1',
        update: [
          '検索ワード履歴を保持できた',
          '画面のポジションを保持できた',
          'マウスを振ってメイン画面を表示できるようになった',
          'タブレート版を作成できた',
          'インストール版を作成できた'
        ]
      },
      {
        time: '2015年3月22日',
        ver: 'V3.1',
        update: [
          'インデックス更新：一定のアイドル時間が続くと更新します',
          '非常駐モードの増強：インデックス更新機能を実現、「即更新」ボタンを押せば、インデックス更新できるようにしました',
          'インデックスデータが更新したら、検索リストを自動的に更新します'
        ]
      },
      {
        time: '2015年1月12日',
        ver: 'V3.0',
        update: [
          'ホットキーなしに設定可能になります',
          'ホットキーで画面を呼び出す時、前回の検索キーワードを全選択にする',
          'アプリケーション終了時、メイン画面及び左右のビューのサイズを覚え、次回開く時、元のサイズに戻る。(例:左右のビューの比率を調整して、メイン画面の「その他機能」ー>「終了」ボタンを押すと、設定は保存されます)',
          '外部プログラムでファイル開く時、検索すると検索しない両方も可能にする',
          '指定時刻でインデックス更新の設定に、自動シャットダウンオプションをつける可能、夜間インデックス作成したら、自動シャットダウンできる',
          'オプション設定ダイアログにユーザ登録ボタンを追加した'
        ]
      },
      {
        time: '2014年9月28日',
        ver: 'V2.8.9.2',
        update: [
          'GUI更改:テーブレットも正しく表示できるようにGUIの表現を更改'
        ]
      },
      {
        time: '2014年9月7日',
        ver: 'V2.8.9.1',
        update: [
          '障害対応：現象：パスワードをかけるPDFファイルが存在する場合、インデックスデータ作成処理は途中で中止してしまった。対応：PDF解析にエラー発生したら、該当ファイルをスキップして、処理を続けるようにした'
        ]
      },
      {
        time: '2014年8月29日',
        ver: 'V2.8.9',
        update: [
          'GUI更改:ファイルの表示アイコンを新しいデザインにした',
          'PDFファイルに対して、ページ情報を解析できるようにした.検索結果のPDFファイルに対して、右クリックして、PDFのページへ飛ぶ機能を実現した'
        ]
      },
      {
        time: '2014年7月25日',
        ver: 'V2.8.8',
        update: [
          'GUI更改:ソート機能・絞り検索機能及び各種検索結果のビュー機能をアイコン化して、ワンクリックしてアクセス',
          'インデックスデータの自動更新設定:「オプション」－>その他」タブに指定した時間・指定した間隔 或は手動でインデックスデータを自動更新'
        ]
      },
      {
        time: '2014年6月20日',
        ver: 'V2.8.7',
        update: [
          'テキスト表示領域に文字の折り返し表示及びフォント変更が実装した',
          'ファイルのコピー・移動・削除が可能: 複数ファイルを選択する場合、CtrlまたはShiftキー押してファイルをクリックして、画面上のコピー・移動ボタンを押せば、ファイルのコピー先・移動先を指定できます。Ctrl+Aの場合、すべてのファイルは操作対象になる.コピー先に同名ファイルすでに存在している場合、上書きかどうかの選択可能',
          'システムトレー領域の複数アイコンの障害が修正',
          '「購入サイトへ」ボタンを追加'
        ]
      },
      {
        time: '2014年5月3日',
        ver: 'V2.8.6',
        update: [
          '一太郎ソフトウェアと連動する。一太郎がインストールしてあるPCに対して、IFILTERで検索できないファイルに、一太郎を起動させて、データをインデックス化して検索できるようにする'
        ]
      },
      {
        time: '2014年4月12日',
        ver: 'V2.8.5',
        update: [
          '近傍検索（近接検索）機能の実現。[キーワードA　W5 キーワードB] =>「A、Bの間５単語以内」の状態を検索する',
          'PDF Xchange Viewerと連動できて、検索用語を渡して、用語位置リストが表示できるようにした',
          'SJIS,Unicodeなど各種フォーマットのテキストを支持する'
        ]
      },
      {
        time: '2014年2月6日',
        ver: 'V2.8.4',
        update: [
          'ご利用環境に対して、IFILTERのインストール状態を検知する機能を追加した',
          'インデックス作成時及び検索時、メイン画面にGIF動画で「処理中」を表すようにしました',
          'アンインストールツールを実行させると、実行中の全文検索くんを検知し、停止させてから、フォルダーにあるすべてのファイルを削除するようにした',
          '第三社のIFILTERによる処理エラーを検知して、継続処理できるようにした'
        ]
      },
      {
        time: '2013年12月14日',
        ver: 'V2.8.3',
        update: [
          '障害対応：ファイル名検索で日本語も検索可能にしました',
          'XPS　IFILTERサポートした。MICROSOFT社のIFILTERをダウンロードしてインストールすれば、XPSを検索可能になる。IFILTERサポートについて、詳細は本サイトのリンクページをご参照してください',
          'IFILTERのテキスト抽出プログラムが利用可能なメモリの増加、１０MB以上４０M（目安）のファイルも対応できるようにしました',
          '検索結果リスト項目の高さが手動で設定できるようにしました。設定ファイル（Config.xml）に下記パラメタの設定が可能になった。<TableHeight>70</TableHeight>TableHeightの値はピックセル単位です'
        ]
      },
      {
        time: '2013年11月10日',
        ver: 'V2.8.2',
        update: [
          '「オプション」画面に検索結果リスト表示順を設定できるようにした(この機能をご利用する場合、インデックスの再作成が必要)',
          'IFILTERサポートした。これにより、メーカーのIFILTERをダウンロードしてインストールすれば、一太郎、Xerox Document,縦書きPDFなどを検索可能になる。IFILTERサポートについて、詳細は本サイトのリンクページをご参照してください'
        ]
      },
      {
        time: '2013年9月16日',
        ver: 'V2.8',
        update: [
          '「オプション」画面を整理して、タブでグルーピング化した',
          '入力語の分析するかどうかオプションを追加',
          'フォルダーを整理して、実行プログラムをフォルダー外に出す',
          'プライベートＪＲＥを添付した 、外部ＪＡＶＡ環境に依存しないようにした'
        ]
      },
      {
        time: '2013年8月2日',
        ver: 'V2.7.2',
        update: [
          '「次のキーワードへ」ボタンを追加、つまり、該当ファイルの全テキスト内容を表示したら、キーワードのある場所にフォーカスを移すことを実装した',
          '多国言語をサポート機能を追加',
          'テキスト内容を選択したり、コピーしたりできるようにした',
          'オプション画面に処理対象ファイルの指定が可能になった。指定がない場合、全ファイルは処理対象にする'
        ]
      },
      {
        time: '2013年6月30日',
        ver: 'V2.7.1',
        update: [
          'Win7では一部の検索結果リスト表示の途切れに対して、表示幅を調整した',
          '検索結果となる文章内容にキーワードをハイライトさせるようにした',
          'キーワードの該当行前後内容を表示する機能（抜粋機能）の実現',
          '一旦中止になったインデックスデータ作成は中止したところから再開できるようにした.インデックス作成完了していないフォルダーに対してインデックスデータの自動更新はしません',
          '最大利用メモリを設定できるツールを提供した',
          'サイズの大きいファイルについてインデックス作成時メモリが足りなかったら、スキップするかメモリを追加するか処理できるようになった',
          'PDFの外部開くプログラムについてIEを経由しないようにした'
        ]
      },
      {
        time: '2013年5月11日',
        ver: 'V2.6',
        update: [
          '「ファイル名でソートする」機能の変更,検索結果に対して、ソート基準はフールパスではなく、ファイル名にした',
          '「検索結果表示」機能に「該当行の前後5行を含んで表示する」機能を追加,つまり、「該当内容の抜粋を表示する」機能を追加した',
          '該当行のハイライト機能、「該当内容の抜粋表示」機能、「テキスト内容の表示」機能に該当行をハイライトした',
          '時間かかる処理に対してスレッド化、「テキスト内容の表示」機能、「該当行まで検索」機能、「該当内容の抜粋を表示する」機能をスレッド化して、大きいなファイルの処理でも、プロセス状態を表示できで、フリーズ感がないことにした',
          'テキストボックス表示内容の切り替え、右側のテキストボックスにも右メニューを追加して、「テキスト内容の表示」と「該当内容の抜粋を表示する」を切り替えることができた',
          '障害対応：複数キーでの内容検索、V2.6版前の各バージョンでは、「該当行まで検索」機能に対して、AND・ORを利用して複数キー検索する場合、該当行を検出できるようになりました',
          'ログ出力：処理失敗したものに対してエラーログを出力、インデックス作成処理で失敗したファイルに対して、エラーを検知し、ログに出力する機能を追加しました',
          '「該当行まで検索」表示順を変更、V2.6版前の各バージョンでは、上記機能の結果表示にSimilarity（相似度）の点数順で表示してきたが、V2.6版から行番号順で表示する'
        ]
      },
      {
        time: '2013年4月6日',
        ver: 'V2.5',
        update: [
          'アンインストールツールを実装した（DeleteTool.exe)',
          '検索結果ソート（更新時間昇順、降順）を実現',
          '検索結果をテキストへ出力機能を追加',
          'ホットキー機能の増強',
          'インデックスデータ保存場所のデフォルト値を設定',
          'インデックスデータ作成機能の増強（サイズの大きいファイルへの対応）'
        ]
      },
      {
        time: '2013年2月16日',
        ver: 'V2.4',
        update: [
          '画面を見直した',
          '検索結果ソート（ファイル名順、更新時間順、ファイルタイプ順）、絞込み機能を追加（ファイルタイプ、更新時間）',
          '検索結果をテキストへ出力機能を追加',
          '複数キーワードのAND/OR/NOT検索を実現',
          'ファイル名検索機能を追加'
        ]
      },
      {
        time: '2013年1月6日',
        ver: 'V2.3',
        update: [
          '「外部プログラムで開く」機能を増強、ファイルを開くとともに検索をかけ、該当文字をハイライト表示',
          'インデックス作成機能を強化',
          '検索画面を表示させるホットキーはユーザ設定できるようにしました',
          '説明書を更新しました'
        ]
      },
      {
        time: '2012年12月25日',
        ver: 'V2.01D',
        update: [
          'インデックス作成時、処理しているファイル名をメッセージに表示する',
          '圧縮ファイルを処理対象から排除するように設定'
        ]
      },
      {
        time: '2012年12月12日',
        ver: 'V2.01',
        update: [
          'インデックスデータ作成機能を強化.複雑な算式、画像つきPDFを解析できるようにしました',
          'Ctrl+Shiftで検索画面を表示'
        ]
      },
      {
        time: '2012年11月25日',
        ver: 'V2.0',
        update: [
          '検索対象監視機能およびインデックス自動更新機能の実現',
          'トレーモードの実現',
          'インデックス作成機能の速度改善',
          '二回連続Ctrlキーで検索画面を表示'
        ]
      },
      {
        time: '2012年10月14日',
        ver: 'V1.3.2',
        update: [
          '検索対象から排除するファイルの設定ができるようにしました',
          '検索対象を選ぶための複数フォルダー選択ダイアログの表示速度が改善しました',
          '検索結果リストの各行の最初にファイル名を表示するようにしました',
          '最初目の起動で、表示言語を選択できるようにしました'
        ]
      },
      {
        time: '2012年8月25日',
        ver: 'V1.3',
        update: [
          '複数フォルダーに対してひとつインデックスを作成できるようにしました',
          '検索ボタンの配置位置を変更しました',
          '右クリックしたら、ファイルオープン機能、行検索機能などをメニューにでるようにしました',
          '選択したファイルのフォルダーを開く機能を追加しました',
          '検索開始際のメッセージダイアログ機能を再調整しました:A.インデックス作成してから検索 B.そのままインデックス利用して検索 C.操作をキャンセル 上記三つの選択ができるようにしました'
        ]
      },
      {
        time: '2012年8月12日',
        ver: 'V1.2.1',
        update: [
          'ヘルプボタンを追加'
        ]
      },
      {
        time: '2012年8月2日',
        ver: 'V1.2',
        update: [
          '日本語、英語、中国語対応、複数インデックスデータ管理機能を追加'
        ]
      },
      {
        time: '2012年7月30日',
        ver: 'V1.1',
        update: [
          'XP上のList表示の不具合を修正'
        ]
      },
      {
        time: '2012年6月8日',
        ver: 'V1.0',
        update: [
          '初公開'
        ]
      }
    ]
  },
  meta: {
    defaultTitle: '全文検索くん(Search++) - インデックス型全文検索ツール',
    defaultDescription: '大量のドキュメントから瞬時に目的の情報を探し出す、高速・軽量なインデックス型全文検索ツール。Windows, Mac対応。',
    index: {
      title: '全文検索くん(Search++) - インデックス型全文検索ツール',
      description: '大量のドキュメントから瞬時に目的の情報を探し出す、高速・軽量なインデックス型全文検索ツール。Windows, Mac対応。'
    },
    feature: {
      title: '特徴・機能 - 全文検索くん(Search++)',
      description: 'MS Office、PDF、一太郎など多種多様なフォーマットに対応。高速なインデックス作成と充実したプレビュー機能。'
    },
    release: {
      title: '更新履歴 - 全文検索くん(Search++)',
      description: '全文検索くん(Search++)の最新アップデート、新機能の追加、バグ修正の履歴。'
    },
    voc: {
      title: 'お客様の声 - 全文検索くん(Search++)',
      description: '全文検索くん(Search++)をご利用いただいているユーザー様からの評価と感想。'
    },
    download: {
      title: 'ご購入・ダウンロード - 全文検索くん(Search++)',
      description: '全文検索くん(Search++)のStd版、Pro版、Mac版のご購入と最新版のダウンロード。'
    },
    link: {
      title: 'リンク集 - 全文検索くん(Search++)',
      description: '全文検索技術や便利なツールに関連するお役立ちリンク集。'
    },
    contact: {
      title: 'FAQ・お問い合わせ - 全文検索くん(Search++)',
      description: '全文検索くん(Search++)に関するよくある質問と、不具合・要望のお問い合わせ。'
    },
    register: {
      title: 'ユーザ登録 - 全文検索くん(Search++)',
      description: '全文検索くん(Search++)の正規ユーザー登録ページ。'
    },
    query: {
      title: 'オンライン検索(デモ) - 全文検索くん(Search++)',
      description: '全文検索くんのWebインターフェースデモンストレーション。'
    },
    mojiscan: {
      title: '文字スキャン(MojiScan) - 完全ローカル処理の日本語OCR・PDFツール',
      description: 'PDF・画像から日本語テキストを抽出し、非表示テキストレイヤー付きの検索可能 PDF を作成する完全ローカル処理の日本語OCR・PDFツール。ファイルはアップロードされません。MojiScan v{version} ({zipName})、{price}。Search++連携対応。'
    },
    bookmarksearch: {
      title: 'ブックマーク検索 (BookMarkSearch) - 完全ローカル処理のブックマーク・閲覧履歴全文検索ツール',
      description: 'ブラウザのブックマークと閲覧履歴をタイトル・URL・ページ本文から全文検索する完全ローカル処理のツール。ファイルはアップロードされません。BookMarkSearch v{version} ({zipName})、{price}。Search++シリーズ。'
    }
  }
}
